export const moduleKeys = {
  rentalOrder: 'rentalOrder',
  core: 'core',
  vehicles: 'vehicles',
  sourcing: 'sourcing',
  quickPurchase: 'quickPurchase',
  customers: 'customers',
  businessCase: 'business-case',
  accounting: 'accounting',
  employee: 'employee',
  workshop: 'workshop',
  warehouse: 'warehouse',
  restrictedArea: 'restricted-area',
  inspection: 'inspection',
  settings: 'settings',
  analytics: 'analytics',
  tiresInventory: 'tires-inventory',
  interest: 'interest',
  taskManager: 'task-manager',
  myProfile: 'my-profile',
  import: 'import',
  opportunitiesKanban: 'opportunities-kanban',
} as const;
